import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { EBOOKS } from "./ebooks";

export default function PlaybookTeaser() {
  return (
    <section id="playbook-teaser" data-testid="playbook-teaser" className="py-14 md:py-20 bg-surface">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-4 mb-8 md:mb-12">
          <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-signal">§ 05½ — The Operator&apos;s Manual</span>
          <span className="flex-1 h-px bg-line" />
          <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-ink2">4 ebooks · from $39</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-14 items-center">
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.7 }}
            className="md:col-span-6"
          >
            <h2 className="font-heading font-black text-5xl md:text-7xl leading-[0.9] tracking-tightest">
              Paid media, <br />
              <span className="text-signal">end to end.</span>
            </h2>
            <p className="mt-6 md:mt-8 text-base md:text-xl text-ink2 leading-relaxed max-w-2xl">
              Four field manuals — LinkedIn, Google, Meta and Bing Ads — for running each platform as a
              real B2B pipeline channel. Sixteen sections each, from account structure to launch checklists.
            </p>
            <div className="mt-10">
              <Link
                to="/playbook"
                data-testid="teaser-cta-primary"
                className="inline-flex items-center gap-3 bg-ink text-paper hover:bg-signal px-8 py-5 font-heading font-bold text-[13px] uppercase tracking-[0.2em] transition-colors"
              >
                Explore the ebooks <ArrowUpRight size={16} />
              </Link>
            </div>
          </motion.div>

          <div className="md:col-span-6 grid grid-cols-2 gap-4" data-testid="teaser-covers">
            {EBOOKS.map((b) => (
              <Link
                key={b.slug}
                to={`/playbook/${b.slug}`}
                data-testid={`teaser-cover-${b.slug}`}
                className="block border border-ink overflow-hidden hover:shadow-[8px_8px_0_0_#E63946] hover:-translate-y-1 transition-[transform,box-shadow]"
              >
                <img src={b.cover} alt={`${b.platform}, end-to-end — Vol. ${b.vol} ebook cover`} className="w-full aspect-[910/1287] object-cover" loading="lazy" />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
